import { CompanyGradeExpirationCode } from '#data/CompanyGradeExpirationCode.enum';
import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

const gradeDetails: ControllerDetails = {
  controlCode: 'CompanyGrade',
  statusCode: ControllerStatus.CHECK_SUCCESS,
  check: {
    requestDateTime: '2023-05-18T13:29:56.409Z',
    responseDateTime: '2023-05-18T13:29:56.409Z',
    requestorId: 'CVE',
    expirationDateTime: '2023-09-26T00:00:00.000Z',
    controlData: {
      companyId: '113',
      expirationCode: CompanyGradeExpirationCode.LAST_REFRESH_TOO_OLD,
      grade: {
        gradeCode: '02',
        lastRefreshDate: '2022-09-26',
      },
    },
  },
};

export const gradeExpiredMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyGrade$',
    },
    response: {
      status: 200,
      body: gradeDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        companyId: '113',
        lineOfBusiness: LineOfBusiness.TCI,
        creation: {
          creationDateTime: '2023-05-18T13:29:56.409Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        customProperties: {},
        iterationId: 'iterationId',
        statusCode: IterationStatusCode.CREATED,
        controls: [gradeDetails],
      } satisfies VettingIteration,
    },
  },
];
